// React
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
// Stores
import LoggedUserStore from '../../stores/LoggedUserStore';
// Material components
import { withStyles } from '@mui/styles';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Tooltip from '@mui/material/Tooltip';

class Sidebar extends React.Component {

    state = {
        rights: LoggedUserStore.getCurrentRights()
    };

    static propTypes = {
        classes: PropTypes.object.isRequired,
        routes: PropTypes.array,
        sidebarOpen: PropTypes.bool,
        handleDrawerClose: PropTypes.func
    };

    activeRoute = (routeName) => window.location.pathname.indexOf(routeName) > -1;

    updateRights = (rights) => {
        this.setState({
            rights,
        });
    };

    isAuthorized = (routeName) => {
        if (!routeName || this.state.rights.includes(routeName) === true)
            return true;
        return false;
    };

    componentDidMount() {
        LoggedUserStore.addChangeListener(this.onLoggedUserStoreChange);
        this.mounted = true;
    }

    componentWillUnmount() {
        LoggedUserStore.removeChangeListener(this.onLoggedUserStoreChange);
        this.mounted = false;
    }

    onLoggedUserStoreChange = () => {
        if (!this.mounted) {
            return false;
        }
        this.updateRights(LoggedUserStore.getCurrentRights());
    };

    renderList = () => {
        const { classes } = this.props;

        return this.props.routes.map((route, key) => {
            if (route.redirect) return null;
            if (route.path === '/login') return null;
            if (!route.sidebarName) return null;
            if (this.isAuthorized(route.rightName) === false) return null;
            if (this.state.minimized) {
                return (
                    <NavLink
                        to={route.path}
                        key={key}
                        activeClassName='active'
                        className={classes.navLink}>
                        <ListItem button >
                            <ListItemIcon>
                                {route.icon}
                            </ListItemIcon>
                        </ListItem>
                    </NavLink>
                );
            }

            return (
                <NavLink
                    to={route.path}
                    key={key}
                    className={classes.navLink}>
                    <Tooltip title={route.sidebarName} placement='right'>
                        <ListItem button
                            key={key}
                            className={classNames(this.activeRoute(route.path) && classes.selectedIcon, classes.listItem)}>
                            <ListItemIcon>
                                {route.icon}
                            </ListItemIcon>
                            <ListItemText primary={route.sidebarName} />
                        </ListItem>
                    </Tooltip>
                </NavLink>
            );
        }
        );
    };

    render() {
        const { classes, sidebarOpen } = this.props;
        return (
            <Drawer
                variant='permanent'
                classes={{
                    paper: classNames(classes.drawerPaper, !sidebarOpen && classes.drawerPaperClose),
                }}
                open={this.props.sidebarOpen}>
                <div className={classes.toolbar}>
                    <IconButton onClick={this.props.handleDrawerClose}>
                        <ChevronLeftIcon />
                    </IconButton>
                </div>
                <List className={classNames(classes.list)}>
                    {this.renderList()}
                </List>
            </Drawer>
        );
    }
}

const drawerWidth = 200;

const styles = theme => ({
    drawerPaper: {
        height: '100vh',
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        overflow: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    navLink: {
        textDecoration: 'none',
        '&:focus': {
            textDecoration: 'none',
        },
        '&:hover': {
            textDecoration: 'none',
            color: theme.palette.green.light,
        },
        '&:visited': {
            textDecoration: 'none'
        },
        '&:link': {
            textDecoration: 'none'
        },
        '&:active': {
            textDecoration: 'none'
        }
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    sidebarIcon: {
        color: theme.palette.green.dark
    },
    selectedIcon: {
        backgroundColor: theme.palette.grey.main
    },
    list: {
        padding: '0px'
    },
    listItem: {
        '&:focus': {
            backgroundColor: theme.palette.grey.main,
        },
    },
    '@media (min-width: 600px)': {
        listItem: {
            paddingLeft: '24px',
            paddingRight: '24px'
        }
    }
});

export default withStyles(styles, { withTheme: true })(Sidebar);
